/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

// This is a SWR middleware for keeping the data even if key changes.
export { laggyMiddleWare } from '@/data/utils/swr/laggyMiddleWare';
